<template>
  <div
    id="phrase-library-form"
    :data-test="
      showEditElements ? 'phrase-library-edit-form' : 'phrase-library-add-form'
    "
    class="panel panel-default panel-fill"
  >
    <div class="panel-heading">
      <h3 class="panel-title">
        {{
          trans(
            showEditElements
              ? "users.phraseLibrary.editPhraseHeader"
              : "users.phraseLibrary.addPhraseHeader",
          )
        }}
      </h3>
    </div>
    <div class="panel-body">
      <form ref="phraseForm" role="form" @submit.prevent="handleSave">
        <div class="row">
          <div class="m-b-20 col-md-12">
            <div
              class="form-group"
              :class="{ 'has-error': formErrors.shorthandErrors }"
            >
              <label for="phrase">{{
                trans("users.phraseLibrary.shortcutLabel")
              }}</label>
              <i class="far fa-asterisk" />
              <input
                v-model="shorthand"
                data-test="phrase-library-shortcut-input"
                class="form-control"
              />
              <small class="form-text text-muted">{{
                trans("users.phraseLibrary.shortcutHelperText")
              }}</small>
              <div
                v-if="formErrors.shorthandErrors?.length"
                data-test="phrase-library-shortcut-error"
              >
                <validation-error :errors="formErrors.shorthandErrors" />
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="form-group"
              :class="{ 'has-error': formErrors.expandedErrors }"
            >
              <label for="phrase">{{
                trans("users.phraseLibrary.expandedTextLabel")
              }}</label>
              <i class="far fa-asterisk" />
              <textarea
                v-model="expanded"
                data-test="phrase-library-expanded-input"
                class="text-area form-control"
                rows="6"
              />
              <div
                v-if="formErrors.expandedErrors?.length"
                data-test="phrase-library-expanded-error"
              >
                <validation-error :errors="formErrors.expandedErrors" />
              </div>
            </div>
          </div>

          <div class="buttons-container">
            <button
              v-if="showEditElements"
              type="button"
              data-test="phrase-library-cancel-button"
              class="btn btn-secondary"
              @click="cancel"
            >
              {{ trans("general.modalCancelButton") }}
            </button>
            <button
              type="submit"
              data-test="phrase-library-save-button"
              class="btn btn-primary"
            >
              {{ trans("users.saveButton") }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ValidationError from "../../../../Utils/ValidationError.vue";

const props = defineProps<{
  shorthandValue: string;
  expandedValue: string;
  formErrors: {
    shorthandErrors: string[] | null;
    expandedErrors: string[] | null;
  };
  showEditElements?: boolean;
}>();

const emit = defineEmits<{
  "update:shorthandValue": [value: string];
  "update:expandedValue": [value: string];
  onSave: [value: { shorthandValue: string; expandedValue: string }];
  onCancel?: [];
}>();

const shorthand = computed({
  get: () => props.shorthandValue,
  set: (val: string) => emit("update:shorthandValue", val),
});

const expanded = computed({
  get: () => props.expandedValue,
  set: (val: string) => emit("update:expandedValue", val),
});

const handleSave = () => {
  emit("onSave", {
    shorthandValue: shorthand.value,
    expandedValue: expanded.value,
  });
};

const cancel = () => {
  emit("onCancel");
};
</script>
